import React, { useEffect } from 'react';
import { StyledEventsContainer } from './CitysparkEvents.styles.mjs';

const CITYSPARK_SCRIPT_ID = 'citysparkEventsScript';
const CitysparkEvents = ({ className, widgetId }) => {
    // TODO: when we work on the homepage composition, we should consider moving this script addicting to the Next' side.
    // Since on the SSR, we'd not be able to operate with DOM
    useEffect(() => {
        let currentCitysparkScript = document.getElementById(CITYSPARK_SCRIPT_ID);
        if (!currentCitysparkScript) {
            const script = document.createElement('script');
            script.id = CITYSPARK_SCRIPT_ID;
            script.defer = true;
            script.src = '//cdn.cityspark.com/wid/get.js';
            document.body.appendChild(script);
            currentCitysparkScript = script;
        }
        return () => {
            if (currentCitysparkScript) {
                currentCitysparkScript.remove();
            }
        };
    }, []);
    return React.createElement(StyledEventsContainer, { className: className, "data-cswidget": widgetId });
};

export { CitysparkEvents as default };
//# sourceMappingURL=CitysparkEvents.mjs.map
